import React from "react";
import TrustLogo from "../images/tg_logo.svg";

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="footer-menu">
        <div className="row">
          <div className="col-md-2 col-lg-2 col-sm-12 mb-4">
            <img src={TrustLogo} alt="logo" className="img-fluid footer-logo" />
          </div>
          <div className="col-md-2 offset-md-1 offset-lg-1 col-lg-2 col-sm-12">
            <h4>Products</h4>
            <ul>
              <li>TrustGrid</li>
              <li>DeGrid</li>
              <li>vrtYou</li>
            </ul>
          </div>
          <div className="col-md-2 col-lg-2 col-sm-12">
            <h4>Solutions</h4>
            <ul>
              <li>Digital Credentials</li>
              <li>Digital Citizen Identity</li>
              <li>Digital Birth Certificate</li>
              <li>Education Passport</li>
              <li>Personal Health Records</li>
              <li>Vaccinations</li>
              <li>User Identification</li>
              <li>Digital Voting</li>
            </ul>
          </div>
          <div className="col-md-2 col-lg-2 col-sm-12">
            <h4>About us</h4>
            <ul>
              <li>About Us</li>
              <li>Standard Compliance & Assurance</li>
              <li>Articles</li>
              <li>In the media</li>
            </ul>
          </div>

          <div className="col-md-3 col-lg-3 col-sm-12">
            <h4>Contact Us</h4>
            <ul>
              <li>help@trustgrid.com</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="copyright-text">
        <div class="row">
          <div class="col-sm-12 col-md-4 col-lg-4 justify-content-center align-items-center">
            <p>
              Privacy Policy <span>Terms and Conditions</span>
            </p>
          </div>
          <div class="col-sm-12 col-md-5 col-lg-5 justify-content-center align-items-center">
            <p>
              TrustGrid
              <sup>TM</sup> is a trademark of TrustGrid Pty Ltd. All Rights
              Reserved
            </p>
          </div>
          <div class="col-sm-12 col-md-3 col-lg-3 justify-content-center align-items-center">
            <p> &copy; 2024 TrustGrid Pty Ltd.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
